import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { NavbarEffects } from './navbar.effects';

@NgModule({
  imports: [EffectsModule.forFeature([NavbarEffects])],
})
export class NavbarStoreModule {}
